var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"smp-localeMenu"},[_c('single-select-filter',{ref:"selectFilter",attrs:{"options":_vm.localeOptions,"filter-key":"locale","icon":['fas', 'language']},on:{"input":_vm.changeLocale}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }